import axiosClient from "../shared/api/axios-client";

/** React Query key for per-module progress (invalidate after reset or exercise submit). */
export const moduleProgressQueryKey = (moduleId: string) =>
  ["module-progress", moduleId] as const;

export interface ResetModuleProgressResponse {
  resetDone: boolean;
}

/**
 * Interface para relatório de progresso do estudante em um módulo
 */
export interface StudentModuleProgress {
  moduleId: string;
  totalExercises: number;
  answeredExercises: number;
  correctExercises: number;
  incorrectExercises: number;
  progressPercentage: number; // 0-100
  score: number; // 0-100
  averageTime?: number; // em segundos
}

/**
 * API para carregar relatório de progresso de um módulo
 * GET /api/students/modules/{moduleId}/progress
 */
export const apiGetModuleProgress = async (
  moduleId: string
): Promise<StudentModuleProgress> => {
  try {
    const response = await axiosClient.get<StudentModuleProgress>(
      `/students/modules/${moduleId}/progress`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching module progress from API:", error);
    throw error;
  }
};

/**
 * POST /api/students/modules/{moduleId}/reset-progress
 */
export const apiResetModuleProgress = async (
  moduleId: string
): Promise<ResetModuleProgressResponse> => {
  const response = await axiosClient.post<ResetModuleProgressResponse>(
    `/students/modules/${moduleId}/reset-progress`
  );
  return response.data;
};

/**
 * POST /api/students/reset-all-module-progress
 */
export const apiResetAllModuleProgress =
  async (): Promise<ResetModuleProgressResponse> => {
    const response = await axiosClient.post<ResetModuleProgressResponse>(
      "/students/reset-all-module-progress"
    );
    return response.data;
  };

